export default __webpack_public_path__ + "static/media/image-ph-health-briefing-w@3x.9cbb6d9f.png";